import { removeEmptyProperties } from '../../../utils/objectUtils';

// @see https://schema.org/ListItem
export const listItemType = (position, name, item) =>
  removeEmptyProperties({
    '@type': 'ListItem',
    position,
    name,
    item
  });
